export const isMockEnabled = () => {
  return window.localStorage.getItem("isUsersMockEnabled") === "true";
};
